import { type AccountData, type TargetFormat } from '../models'

import { formatCustom } from './custom'
import { formatIam } from './iam'
import { formatWeb } from './web'

export type FormatFn = (account: AccountData) => string

export const FORMATTERS: Record<TargetFormat, FormatFn> = {
  iam: formatIam,
  web: formatWeb,
  custom: formatCustom,
}

export const FORMATTER_NAMES: TargetFormat[] = ['iam', 'web', 'custom']
